module.exports = __webpack_public_path__ + "static/IMG_2308-6999140b5d09f1956d926bdd513e3898.jpg";